export default "__VITE_ASSET__ncui5Ofz__"